import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import TestForm from "../FormularioAltas/TestForm";
import { ProgressSpinner } from "primereact/progressspinner";
import { addUsuariosColaborador, getActiveColaborators, getInactiveColaborators, updateUsuariosColaborators } from "./integracion";
import FormColaborador from "./ColaboradorDetail";
import { addUsuarios, getActiveOperators, getColaboradoresSinUsuario, getLineasTelefono, getOperadoresSinUsuarioAsignado, getTodosLosUsuarios, getUsuarios, updateUsuarios } from "../TablaPersonal/integracion";
import { formateoBasico } from "../../../utilidades/formateos";
import { getClientes } from "../../admin/Bitacoras/integracion";
import InputLista from "../../../components/atoms/InputLista/InputLista";
import {InputIcon} from "primereact/inputicon";
import {IconField} from "primereact/iconfield";
import "../TablaPersonal/TablaPersonal.scss";

const TablaColaboradores = ({ data, showActives, onToggleActives, setVisible, setVisibleEditar, llenarModal }) => {
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [nameInput, setNameInput] = useState('');
    const [dataUsers, setData] = useState(data || []);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editingId, setEditingId] = useState(null);

    const accionesTemplateUsuario = (rowData) => {
        return (
            <Button icon="pi pi-pencil" rounded outlined severity="secondary" aria-label="Bookmark" onClick={() => {
                setVisibleEditar(true);
                llenarModal(rowData)
            }}/>
        );
    };

    const opTable = useRef(null);
    useEffect(() => {
        const parseFecha = (v) => {
            if (!v) return null;
            // dd/mm/yyyy
            const m = String(v).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (m) {
                const [, dd, mm, yyyy] = m;
                const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
                return isNaN(d.getTime()) ? null : d;
            }
            const d = new Date(v);
            return isNaN(d.getTime()) ? null : d;
        };

        // Precalcular timestamps una sola vez
        const enriched = (data || []).map(row => {
            const di = parseFecha(row.INGRESO);
            const db = parseFecha(row.BAJA);
            return {
                ...row,
                INGRESO_TS: di ? di.getTime() : null,
                BAJA_TS: db ? db.getTime() : null
            };
        });
        setData(enriched);
    }, [data]);

    const openEditDialog = (id) => {
        setEditingId(id ?? null);
        setEditDialogOpen(true);
    };

    const closeEditDialog = () => {
        setEditDialogOpen(false);
        setEditingId(null);
        // Opcional: aquí puedes refrescar la tabla si el formulario guarda cambios
        // e.g. onRefresh && onRefresh();
    };



    const exportCSV = () => {
        opTable.current.exportCSV();
    };


    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">

                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText
                        id="globalSearchInput"
                        type="search"
                        value={globalFilterValue}
                        onChange={(e) => setGlobalFilterValue(e.target.value)}
                        placeholder="Buscar por Nombre"
                    />
                </IconField>

                <Button
                    type="button"
                    icon={showActives ? "pi pi-user-minus" : "pi pi-user-plus"}
                    label={showActives ? "Ver Inactivos" : "Ver Activos"}
                    onClick={onToggleActives}
                    className="p-button-secondary"
                    style={{ marginLeft: '20px' }}
                />

                <Button
                    type="button"
                    icon="pi pi-file-excel"
                    label="Exportar Excel"
                    onClick={exportCSV}
                    className="p-button-success"
                    style={{ marginLeft: '20px' }}
                />
                <Button
                    type="button"
                    icon="pi pi-user"
                    label="Crear Usuario"
                    onClick={() => { setVisible(true) }}
                    className="p-button-primary"
                    style={{ marginLeft: '20px' }}
                />
            </div>
        );
    };

    const header = renderHeader();


    // This function will be passed to the DataTable column
    const accionesTemplate = (rowData) => {
        return (
            <Button
                label=""
                rounded outlined
                icon="pi pi-pencil"
                severity="warning"
                onClick={() => openEditDialog(rowData.ID)}
            />
        );
    };
   
    
    return (
        <div className="table-container-th-TP">
            <DataTable
                ref={opTable}
                value={dataUsers} className="custom-table-th" 
                globalFilter={globalFilterValue}
                header={header}
                emptyMessage="No se encontraron colaboradores."
                scrollable
                showGridlines
                scrollWidth="100%"
                scrollHeight="calc(100vh - 150px)"
                virtualScrollerOptions={{ itemSize: 50 }}
            >
                <Column header="" body={accionesTemplate}></Column>
                <Column header="Usuario" body={accionesTemplateUsuario}></Column>

                <Column field="ID" header="ID" sortable></Column>
                <Column field="NOMBRE" header="Nombre" style={{ minWidth: '200px' }}></Column>
                <Column field="PUESTO" header="Puesto" style={{ minWidth: '200px' }}></Column>
                <Column field="DIRECCION" header="Dirección" style={{ minWidth: '120px' }}></Column>
                <Column field="ESCOLARIDAD" header="Escolaridad"></Column>
                <Column field="INGRESO" dataType="date" style={{ minWidth: '96px' }} header="Ingreso" sortable sortField="INGRESO_TS"></Column>
                <Column field="BAJA" header="Baja" sortable sortField="BAJA_TS" style={{ minWidth: '88px' }}></Column>
                <Column field="TELEFONO_CELULAR" header="Teléfono"></Column>
                <Column field="USUARIO" header="Usuario"></Column>
                <Column field="EMAIL" header="Correo"></Column>
                <Column field="IMSS" header="IMSS" style={{ minWidth: '96px' }}></Column>
                <Column field="RFC" header="RFC"></Column>
                <Column field="ESTADO_CIVIL" header="Estado Civil"></Column>
                <Column field="SEXO" header="Sexo"></Column>

            </DataTable>

            <Dialog
                header={editingId ? "Detalle colaborador" : "Nuevo Usuario"}
                visible={editDialogOpen}
                modal
                style={{ width: '80vw', maxWidth: '1200px' }}
                breakpoints={{ '1200px': '90vw', '641px': '98vw' }}
                contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
                onHide={closeEditDialog}
            >
                <FormColaborador usuarioId={editingId} onClose={closeEditDialog} />
            </Dialog>

        </div>
    );
};

export function ColaboradoresView() {
    const [users, setUsers] = useState([]);
    const [unitTypes, setUnitTypes] = useState([]);
    const [licenseTypes, setLicenseTypes] = useState([]);
    const [showActives, setShowActives] = useState(true);

    const [operadoresSinUsuario, setOperadoresSinUsuario] = useState([])
    const [colaboradoresSinUsuario, setColaboradoresSinUsuario] = useState([])
    const [usuarios, setUsuarios] = useState([])
    const [visible, setVisible] = useState(false);
    const [visibleEditar, setVisibleEditar] = useState(false);
    const [clientes, setClientes] = useState([]);
    const [lineasTelefonos, setLineasTelefonos] = useState([]); // <--- FALTANTE
    const [todosLosUsuarios, setTodosLosUsuarios] = useState([]); // <--- FALTANTE

    // Estado único para el formulario de agregar/editar usuario
    const [form, setForm] = useState({
        cliente: { name: "SUMA TE LLEVA", code: 5 },
        nombre: "",
        passMonitor: "",
        passSumaEnLinea: "",
        email: "",
        puesto: null,
        fechaNacimiento: "",
        activo: false,
        acceso: false,
        esOperador: { name: "Administrativo", code: 2 },
        lineasTelefono: { code: -1, name: "Sin linea" },
        operadorSinUsuario: null,
        todosLosUsuario: null,
        idUsuario: null,
        colaborador: null,
    });

    // Placeholders para edición
    const [clientePlaceHolder, setClientePlaceHolder] = useState('');
    const [lineasTelefonoPlaceholder, setLineasTelefonoPlaceholder] = useState('');

    const navigate = useNavigate();

    const llenarModal = (rowData) => {
        setForm(f => ({
            ...f,
            nombre: rowData.NOMBRE_USUARIO,
            passMonitor: rowData.PASS_MONITOR,
            passSumaEnLinea: rowData.PASS_SUMA_EN_LINEA,
            email: rowData.EMAIL_USUARIO,
            fechaNacimiento: formateoBasico(rowData.FECHA_NACIMIENTO),
            lineasTelefono: { code: rowData.LINEA_TELEFONO_ID, name: rowData.LINEA_TELEFONO_TEL },
            activo: rowData.ACTIVO,
            acceso: rowData.ACCESO,
            cliente: { name: rowData.NOMBRE_EMPRESA, code: rowData.ID_EMPRESA },
            esOperador: { name: "Administrativo", code: 2 },
            idUsuario: rowData.USUARIO,
        }));
        setClientePlaceHolder(rowData.NOMBRE_EMPRESA || '');
        setLineasTelefonoPlaceholder(rowData.TELEFONO || '');
    }
    useEffect(() => {
        getClientes(setClientes)
        getLineasTelefono(setLineasTelefonos)
        getTodosLosUsuarios(setTodosLosUsuarios)
        getColaboradoresSinUsuario(setColaboradoresSinUsuario)
    }, [])
    useEffect(() => {
        if (visible == true) {
            setForm(f => ({
                ...f,
                cliente: { name: "SUMA TE LLEVA", code: 5 },
                lineasTelefono: { code: -1, name: "Sin linea" }
            }));
        }
    }, [visible])

    const agregarUsuario = async () => {
        // Usar form en vez de estados individuales
        const { email, lineasTelefono, passMonitor, passSumaEnLinea, todosLosUsuario, colaborador } = form;
        if (email && lineasTelefono && colaborador) {
            const params = {
                // id_cliente: cliente.code,
                nombre: colaborador.name,
                id_colaborador: colaborador.code,
                pass_monitor: passMonitor,
                email: email,
                celular: lineasTelefono?.code,
                pass_suma_en_linea: passSumaEnLinea,
                id_usuario_permiso: todosLosUsuario ? todosLosUsuario.code : 0
            };

            setVisible(false);
            await addUsuariosColaborador(params);
            await getOperadoresSinUsuarioAsignado(setOperadoresSinUsuario);
            await getLineasTelefono(setLineasTelefonos);
            await getActiveColaborators(setUsers);
            limpiarCampos();
        } else {
            alert("Faltan campos por rellenar");
        }
    }

    const limpiarCampos = () => {
        setForm({
            cliente: { name: "SUMA TE LLEVA", code: 5 },
            nombre: "",
            passMonitor: "",
            passSumaEnLinea: "",
            email: "",
            puesto: null,
            fechaNacimiento: "",
            activo: false,
            acceso: false,
            esOperador: { name: "Administrativo", code: 2 },
            lineasTelefono: { code: -1, name: "Sin linea" },
            operadorSinUsuario: null,
            todosLosUsuario: null,
        });
    }
    
    const actualizarUsuario = async () => {
            if (form.nombre && form.email && form.passMonitor && form.passSumaEnLinea ) {
                const params = {
                    id_usuario: form.idUsuario,
                    nombre: form.nombre,
                    pass_monitor: form.passMonitor,
                    email: form.email,
                    celular: form.lineasTelefono ? (form.lineasTelefono.code == -1 ? -1 : form.lineasTelefono.code) : null,
                    pass_suma_en_linea: form.passSumaEnLinea,
                    activo: form.activo === true ? '1' : '0'
                };
                setVisibleEditar(false);
                await updateUsuariosColaborators(params);
                await getUsuarios(setUsuarios);
                await getOperadoresSinUsuarioAsignado(setOperadoresSinUsuario);
                await getLineasTelefono(setLineasTelefonos);
                await getActiveColaborators(setUsers);
                limpiarCampos();
            } else {
                alert("Faltan campos por rellenar");
            }
    }
    // --------------------------------------------------------------------->


    const loadUsers = (activos) => {
        if (activos) {
            // Activos
            getActiveColaborators(setUsers);
        } else {
            // Inactivos
            getInactiveColaborators(setUsers);
        }
    };

    useEffect(() => {
        loadUsers(showActives);
    }, []); // carga inicial

    const handleToggleActives = () => {
        const next = !showActives;
        setShowActives(next);
        loadUsers(next);
    };
    return (
        <div >
            {users.length === 0 ? (
                <div className="loading-container">
                    <div className="loading-content">
                        <ProgressSpinner
                            style={{ width: '60px', height: '60px' }}
                            strokeWidth="8"
                            fill="transparent"
                            animationDuration=".8s"
                        />
                        <p>{showActives ? "Cargando usuarios activos" : "Cargando usuarios inactivos"}</p>
                    </div>
                </div>
            ) : (
                <TablaColaboradores
                    data={users}
                    showActives={showActives}
                    onToggleActives={handleToggleActives}
                    setVisible={setVisible}
                    setVisibleEditar={setVisibleEditar}
                    llenarModal={llenarModal}
                />
            )}
            <Dialog
                header="Agregar Usuario"
                className="dialog"
                visible={visible}
                style={{ width: '70vw', maxWidth: '800px', zIndex: 1 }}
                breakpoints={{ '1200px': '80vw', '768px': '90vw', '641px': '98vw' }}
                onHide={() => { if (!visible) return; setVisible(false); limpiarCampos() }}
                draggable={false}
            >
                <div className="modalInputs">


                    <div style={{ display: "flex", flexDirection: "column", fontSize: "0.9rem" }} className="input-container" data-required="true">
                        <InputLista
                            options={colaboradoresSinUsuario}
                            value={form.colaborador}
                            onChange={(e) => setForm(f => ({ ...f, colaborador: e.value }))}
                            titulo={"Colaboradores Sin Usuario"}
                        />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", fontSize: "0.9rem" }} className="input-container" data-required="true">
                        <label htmlFor="email-input"> <span style={{ color: "red" }}>*</span>Correo Electrónico </label>
                        <InputText
                            id="email-input"
                            type="email"
                            value={form.email}
                            onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))}
                            placeholder="usuario@ejemplo.com"
                        />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", fontSize: "0.9rem" }} className="input-container" data-required="true">
                        <InputLista
                            options={lineasTelefonos}
                            value={form.lineasTelefono}
                            onChange={(e) => setForm(f => ({ ...f, lineasTelefono: e.value }))}
                            titulo={"Número de Celular"}
                        />
                    </div>

                    {form.esOperador.code == 2 && (
                        <>
                            <div className="section-divider"></div>
                            <div className="input-container conditional-field" style={{ display: "flex", flexDirection: "column", fontSize: "0.9rem" }}>
                                <label htmlFor="password-plataformas-input">Password Plataformas</label>
                                <InputText
                                    id="password-plataformas-input"
                                    type="password"
                                    value={form.passMonitor}
                                    onChange={(e) => setForm(f => ({ ...f, passMonitor: e.target.value }))}
                                    placeholder="Contraseña para plataformas"
                                />
                            </div>
                            <div className="input-container conditional-field" style={{ display: "flex", flexDirection: "column", fontSize: "0.9rem" }}>
                                <label htmlFor="password-suma-input">Password Suma en Línea</label>
                                <InputText
                                    id="password-suma-input"
                                    type="password"
                                    value={form.passSumaEnLinea}
                                    onChange={(e) => setForm(f => ({ ...f, passSumaEnLinea: e.target.value }))}
                                    placeholder="Contraseña para Suma en Línea"
                                />
                            </div>
                            <div className="input-container conditional-field" >
                                <InputLista
                                    options={todosLosUsuarios}
                                    value={form.todosLosUsuario}
                                    onChange={(e) => setForm(f => ({ ...f, todosLosUsuario: e.value }))}
                                    titulo={"Copiar permisos de:"}
                                />
                            </div>
                        </>
                    )}
                </div>

                <div className="modal-buttons-tablaPersonal">
                    <Button
                        className="p-button-secondary"
                        icon="pi pi-times"
                        onClick={() => {
                            setVisible(false);
                            limpiarCampos();
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        icon="pi pi-check"
                        onClick={() => { agregarUsuario() }}
                        disabled={
                            !form.email ||
                            !form.cliente ||
                            !form.lineasTelefono ||
                            !form.colaborador
                        }
                    >
                        Guardar Usuario
                    </Button>
                </div>
            </Dialog>
            <Dialog
                header="Editar Usuario"
                className="dialog"
                visible={visibleEditar}
                style={{ width: '70vw', maxWidth: '800px' }}
                breakpoints={{ '1200px': '80vw', '768px': '90vw', '641px': '98vw' }}
                onHide={() => { if (!visibleEditar) return; setVisibleEditar(false); limpiarCampos() }}
                draggable={false}
            >
                <div className="modalInputs">
                    <div className="input-container">
                        <label>Estado del Usuario</label>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '0.75rem 1rem',
                            border: '2px solid var(--border-color)',
                            borderRadius: 'var(--border-radius)',
                            backgroundColor: '#f8f9fa'
                        }}>
                            <input
                                type="checkbox"
                                id="activo-checkbox"
                                checked={form.activo}
                                onChange={(e) => setForm(f => ({ ...f, activo: e.target.checked }))
                                }
                                style={{ transform: 'scale(1.2)' }}
                            />
                            <label htmlFor="activo-checkbox" style={{ margin: 0, fontWeight: 'normal' }}>
                                Usuario Activo
                            </label>
                        </div>
                    </div>

                    {/* Campos para administrativos */}

                    <div className="input-container conditional-field">
                        <label htmlFor="edit-nombre-input">Nombre Completo <span className="required-asterisk">*</span></label>
                        <InputText
                            id="edit-nombre-input"
                            value={form.nombre}
                            onChange={(e) => setForm(f => ({ ...f, nombre: e.target.value }))}
                            placeholder="Ingrese el nombre completo"
                            disabled={true}
                        />
                    </div>
                    <div className="input-container conditional-field">
                        <label htmlFor="edit-email-input">Correo Electrónico <span className="required-asterisk">*</span></label>
                        <InputText
                            id="edit-email-input"
                            type="email"
                            value={form.email}
                            onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))}
                            placeholder="usuario@ejemplo.com"
                        />
                    </div>
                    <div className="input-container conditional-field">
                        <label htmlFor="edit-password-plataformas-input">Password Plataformas</label>
                        <InputText
                            id="edit-password-plataformas-input"
                            type="password"
                            value={form.passMonitor}
                            onChange={(e) => setForm(f => ({ ...f, passMonitor: e.target.value }))}
                            placeholder="Contraseña para plataformas"
                        />
                    </div>
                    <div className="input-container conditional-field">
                        <label htmlFor="edit-password-suma-input">Password Suma en Línea</label>
                        <InputText
                            id="edit-password-suma-input"
                            type="password"
                            value={form.passSumaEnLinea}
                            onChange={(e) => setForm(f => ({ ...f, passSumaEnLinea: e.target.value }))}
                            placeholder="Contraseña para Suma en Línea"
                        />
                    </div>
                    <div className="input-container conditional-field">
                        <InputLista
                            placeholder={form.lineasTelefono ? form.lineasTelefono.name : ''}
                            options={lineasTelefonos}
                            value={form.lineasTelefono}
                            onChange={(e) => setForm(f => ({ ...f, lineasTelefono: e.value }))}
                            titulo={"Número de Celular"}
                        />
                    </div>



                </div>

                <div className="modal-buttons-tablaPersonal">
                    <Button
                        className="p-button-secondary"
                        icon="pi pi-times"
                        onClick={() => { setVisibleEditar(false); limpiarCampos() }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        icon="pi pi-check"
                        onClick={() => { actualizarUsuario() }}
                        disabled={
                            !form.email ||
                            (form.esOperador.code == 2 && (!form.nombre || !form.fechaNacimiento))
                        }
                    >
                        Actualizar Usuario
                    </Button>
                </div>
            </Dialog>
        </div>
    );

}